// extracted by mini-css-extract-plugin
module.exports = {"wohac9x":"wohac9x","a1i377xc":"a1i377xc","a11yvlpg":"a11yvlpg","t1s5uocr":"t1s5uocr"};